import React from 'react';
import image from '@/public/images/careers/careers.webp';
import Image from 'next/image';
import { Icons } from '@/components/icons';

export const Careers = () => {
  return (
    <div>
      <p className="mb-4 text-lg font-normal">
        At Tytum, we’re proud to offer top-quality services with over 20 years
        of experience in the Greater San Diego Area. Our commitment to
        excellence in customer service drives everything we do, from HVAC and
        electrical services to plumbing, remodeling, construction, and real
        estate.
      </p>
      <p className="mb-4 text-lg font-normal">
        If you’re passionate about your craft and dedicated to making a
        difference, Tytum is the place for you. Explore our career opportunities
        and become part of a team that values expertise, customer satisfaction,
        and community commitment.
      </p>
      <div className="mb-8 flex justify-center">
        <Image src={image} alt="Join the Tytum Team" />
      </div>

      <p className="mb-8 text-2xl font-semibold">Why Work with Us?</p>

      <ul className="mb-8">
        <li className="mb-10 flex gap-6">
          <Icons.checkIcon />
          <p>
            <span className="font-semibold">Certified Experts: </span>
            <span>
              Join a team of fully licensed and insured professionals who excel
              in their fields.
            </span>
          </p>
        </li>

        <li className="mb-10 flex gap-6">
          <Icons.checkIcon />
          <p>
            <span className="font-semibold">Customer Satisfaction: </span>
            <span>
              Be part of a company that prioritizes customer comfort and
              satisfaction with reliable services.
            </span>
          </p>
        </li>

        <li className="mb-10 flex gap-6">
          <Icons.checkIcon />
          <p>
            <span className="font-semibold">Community Focused: </span>
            <span>
              Work locally in the San Diego area, providing personalized service
              and building strong community ties
            </span>
          </p>
        </li>
      </ul>

      <p className="mb-8 text-2xl font-semibold">Ready to Make a Difference?</p>

      <p className="mb-4 text-lg font-normal">
        If you’re passionate about delivering high-quality service and want to
        grow your career with a dedicated and experienced team, we’d love to
        hear from you! Explore opportunities with Tytum and help us continue to
        set the standard for excellence.
      </p>
    </div>
  );
};
